import { useFormikContext } from "formik";
import { useCallback, useEffect, useState } from "react";

function AutoSubmit(props: {
  ignoreDirty?: boolean;
}) {
  /*
      This component is used to automatically submit the form when the form is valid
      and has been changed(dirty).
     */

  const { submitForm, isValid, values, dirty } = useFormikContext();

  const [currentValues, setCurrentValues] = useState<any>(values);

  function submit() {
    if (values !== currentValues) {
      void submitForm();
      setCurrentValues(values);
    }
  }

  const s = useCallback(submit, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want this to trigger for changes
  useEffect(() => {
    const handler = setTimeout(() => {
      submit();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [isValid, values, dirty, submitForm, props.ignoreDirty, s]);
  return <></>;
}

export default AutoSubmit;
